<template>
  <div :class="['paymented-list',{'app':isNativeApp}]">
    <!-- 方案解析列表 -->
    <div v-show="solutions.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :offset="80"
        @load="onLoad"
      >
        <div class="list-content">
          <van-row class="list-item" v-for="(item, index) of solutions" :key="index">
            <router-link :to="`/solutions/detail/${item.solutionId}.html`">
              <van-col :span="18">
                <van-row  class="list-item-title">
                  <div><i class="blue_icon"></i> {{item.solutionName}}</div>
                </van-row>
                <van-row class="list-item-count">
                  <div class="item-user"><img src="../assets/images/icon_on.png" alt="">{{item.userName?item.userName:'佚名'}}</div>
                </van-row>
              </van-col>
              <van-col :span="6" class="list-item-btn">
                <span>下载</span>
                <!-- <router-link :to="`/download/${item.solutionId}.html`"><span>下载</span></router-link> -->
                <!-- /download/:id.html -->
              </van-col>
            </router-link>
          </van-row>
        </div>
      </van-list>
    </div>
    <noPaymentList v-show="solutions.length <= 0"></noPaymentList>
  </div>
</template>

<script>
import { textSlice, myriabit } from '@/filters/commonFilters'
import { getCollectList } from '@/api/news/news'
import noPaymentList from '@/components/noPaymentList'
import { toLogin } from '@/utils/common'
import { getCookie } from '@/utils/cookies'
export default {
  name: 'collectList',
  filters: {
    textSlice,
    myriabit
  },
  components: { noPaymentList },
  data () {
    return {
      loading: false,
      finished: false,
      paramsData: {
        current: 1,
        size: 10,
        userId: null
      },
      solutions: [],
      noData: false,
      noResultData: {
        typeName: '方案',
        callback: 'callback'
      },
      defaultImg: '../assets/images/icon_user.png',
      isNativeApp: true
    }
  },
  created () {
    this.getData()
    this.paramsData.userId = getCookie('accountId')
    this.isNativeApp = !!(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
    if ($HMD$.rNavigator && $HMD$.rNavigator !== 'msite' && !this.paramsData.userId) {
      let _this = this
      $HMD$.GetLogin(function (data) {
        if (data.AccountId) {
          _this.paramsData.userId = data.AccountId
        } else {
          toLogin()
        }
      })
    }
  },
  methods: {
    onLoad () {
      // 调用查询接口
      let self = this
      this.paramsData.current++
      getCollectList(this.paramsData).then(result => {
        if (result && result.status === 200 && result.data && result.data.respCode === '0000' && result.data.data && result.data.data.records && result.data.data.records.length > 0) {
          self.solutions = self.solutions.concat(result.data.data.records)
          self.paramsData.current = result.data.data.current
          window.setTimeout(() => {
            self.loading = false
            if (result.data.data.current === result.data.data.pages) {
              self.finished = true
            }
          }, 1000)
        } else if (result.status === 200 && result.data.code == 460){
          toLogin()
        } else {
          self.loading = false
          self.finished = true
        }
      }).catch(() => {
        self.loading = false
        self.paramsData.total = 0
      })
    },
    getData () {
      this.paramsData.current = 0
      this.paramsData.size = 10
      this.finished = false
      this.noData = false
      this.onLoad()
    },
    toListSelf () {
      this.getData()
    }
  }
}
</script>

<style scoped lang="scss">

@mixin TwoLine {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.paymented-list.app{
  margin-top: 1.2rem;
}
.paymented-list{
  margin-top: 2.65rem;
  .list-content{
    border-bottom: 1px solid #D8D8D8;
    .list-item{
      margin-top: 10px;
      background-color: #ffffff;
      padding: 16px 16px 13px 16px;
      position: relative;
      .list-item-title{
        font-size: 14px;
        font-weight: 400;
        color: #222222;
        div{
          // min-height:16px;
          display: flex;
        .blue_icon{
          flex-shrink: 0;
          width: 3px;
          height: 16px;
          border-radius: 3px;
          margin: 0 15px 0 7px;
          background: #2F7BFF;
        }
        }
      }
      .list-item-count{
        .item-user{
          position: relative;
          font-size: 12px;
          font-weight: 400;
          color: #9B9B9B;
          padding-left: 24px;
          margin-top: 5px;
          img{
            width: 14px;
            height: 14px;
            position: absolute;
            top: 1px;
            left: 0;
          }
        }
      }
      .list-item-btn{
        span{
          display: inline-block;
          width: 47px;
          height: 24px;
          background: #2F7BFF;
          border-radius: 2px;
          border: 1px solid #2F7BFF;
          font-size: 12px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
          text-align: center;
          position: absolute;
          right: 16px;
          top: 30%;
        }
      }
    }
  }
  .no-data-content{
    background-color: #f5f5f5;
    text-align: center;
    padding-top: 111px;
    .describe-content{
      p{
        font-size: 14px;
        color: #a0a0a0;
        margin: 0px;
      }
    }
    .button-content{
      button{
        margin-top: 40px;
        width: 200px;
        height: 44px;
        background-color: #1dbfda;
        color: white;
        border: none;
        border-radius: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collectionList.vue